document.querySelectorAll("#js-site-nav > ul > li").forEach((ele) => {
  ele.querySelector("ul").classList.add("for-hotjar");
  ele.addEventListener("mouseenter", (ev) => {
    const menu = ev.target.querySelector("ul");
    menu.classList.add("for-hotjar-active");
    menu.classList.remove("for-hotjar");
  });
  ele.addEventListener("mouseleave", (ev) => {
    const menu = ev.target.querySelector("ul");
    menu.classList.add("for-hotjar");
    menu.classList.remove("for-hotjar-active");
  });
});
